<script>
import { required, numeric } from "vuelidate/lib/validators";
import validationMessages from "@/components/validations";
import Merchandising from "@/services/Merchandising";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";
import moment from "moment";
import vue2Dropzone from "vue2-dropzone"
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  props:['campaignData'],
  components: { validationMessages,DatePicker,vueDropzone: vue2Dropzone },

  data() {
    return {
      showModal: false,
      submitted: false,
      tryingToSubmit: false,
      showLoader: false,
      csrf_token: localStorage.getItem("csrf_token"),
      campaignName:'',
      campaignImage:'',
      campaignDateFrom:'',
      campaignDateTo:'',
      campaignGUID:'',
      imageRemoved:false,
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: true,
        thumbnailWidth: 200,
        thumbnailMethod: 'contain',
        maxFilesize: 2,
        acceptedFiles:'image/*',
        maxFiles: 1,
      },

    };
  },

  validations: {
    campaignName: { required },
    campaignDateFrom: { required },
    campaignDateTo: { required },
  },

  methods: {
    removeImage(){
      this.campaignImage = '';
      this.imageRemoved = true;
    },
    selectFile(files){
      setTimeout(() => {
        let queuedFiles = this.$refs.myVueDropzone_primary.getQueuedFiles();
        if (queuedFiles.length > 1) {
          this.failedmsg('You can only have one image')
          files.forEach((value) => {
            this.$refs.myVueDropzone_primary.removeFile(value)
          });
        }
        this.campaignImage = queuedFiles[0];
      }, 250);
    },
    async submitForm() {
      this.tryingToSubmit = true;

      if (this.$v.$invalid) {
        this.submitted = true;
        this.tryingToSubmit = false;
        return;
      }

      this.showLoader = true;
      // let payload= {
      //   campaign_name: this.campaignName,
      //   date_from:moment(this.campaignDateFrom).format('YYYY-MM-DD'),
      //   date_to: moment(this.campaignDateTo).format('YYYY-MM-DD'),
      // }

      let formData = new FormData();
      formData.append("campaign_name", this.campaignName);
      formData.append("campaign_image", this.campaignImage);
      formData.append("date_from",moment(this.campaignDateFrom).format('YYYY-MM-DD'));
      formData.append("date_to", moment(this.campaignDateTo).format('YYYY-MM-DD'));
      formData.append('_method', 'PATCH');

      try {
        const response = await Merchandising.updateMerchandiseCampaign(this.campaignGUID,formData);
        if (response.data.data.error) {
          Swal.fire("Error", response.data.data.error || "Failed to update campaign. Please try again.", "error");
        } else {
          Swal.fire("Success", "Campaign successfully updated!", "success");
          this.closeModal();
          this.refreshData();
        }

      } catch (error) {
        // Catch any network or unexpected errors
        console.error("Failed to create campaign:", error);
        Swal.fire("Error", error.response?.data?.error || "Failed to create campaign. Please try again.", "error");
      } finally {
        this.tryingToSubmit = false;
        this.showLoader = false;
      }
    },


    resetForm() {
      this.$v.$reset();
      this.campaignName = '';
      this.campaignDateFrom = '';
      this.campaignImage = '';
      this.campaignDateTo = '';
      this.showLoader = false;
      this.submitted = false;
    },

    closeModal() {
      this.resetForm();
      this.showModal = false;
    },

    syncData(){
      this.campaignGUID = this.campaignData.campaign_guid;
      this.campaignName = this.campaignData.campaign_name;
      this.campaignImage = this.campaignData.campaign_image;
      this.campaignDateFrom = new Date(this.campaignData.date_from);
      this.campaignDateTo = new Date(this.campaignData.date_to);

      if(this.campaignImage === '' || this.campaignImage === null){
        this.imageRemoved = true;
      }else{
        this.imageRemoved = false;
      }
    },


    refreshData() {
      this.$emit("onRefresh");
    },
  },
};
</script>

<template>
  <b-modal
      @hidden="resetForm"
      @shown="syncData"
      id="edit_campaign"
      size="l"
      v-model="showModal"
      title="Edit Campaign"
      title-class="font-18"
  >
    <form @submit.prevent="submitForm">
      <div class="row">
        <div v-if="$v.$error" class="text-danger">Complete all fields</div>
        <div v-if="showLoader" class="card-body d-flex align-items-center justify-content-center">
          <b-spinner large></b-spinner>
        </div>
        <div v-else>
          <b-card-text>
            <b-form-group label="Campaign Name" label-for="formrow-campaign-name-input" class="mb-3">
              <b-form-input
                  v-model.trim="campaignName"
                  :class="{ 'is-invalid': submitted && $v.campaignName.$error }"
              ></b-form-input>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Campaign Name'"
                  :validationName="$v.campaignName"
              ></validationMessages>
            </b-form-group>

            <b-form-group label="Start Date" label-for="formrow-start_date-input" class="mb-3">
              <date-picker
                  v-model="campaignDateFrom"
                  append-to-body
                  :class="{ 'is-invalid': submitted && $v.campaignDateFrom.$error }"
                  lang="en"
                  confirm
                  format="YYYY-MM-DD"
              ></date-picker>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Campaign Start'"
                  :validationName="$v.campaignDateFrom"
              ></validationMessages>
            </b-form-group>
            <b-form-group label="End Date" label-for="formrow-end_date-input" class="mb-3">
              <date-picker
                  v-model="campaignDateTo"
                  append-to-body
                  :class="{ 'is-invalid': submitted && $v.campaignDateTo.$error }"
                  lang="en"
                  confirm
                  format="YYYY-MM-DD"
              ></date-picker>
              <validationMessages
                  v-if="submitted"
                  :fieldName="'Campaign End'"
                  :validationName="$v.campaignDateTo"
              ></validationMessages>
            </b-form-group>
            <b-form-group  label="Campaign Image" label-for="formrow-end_date-input" class="mb-3">
              <div  v-if="!imageRemoved" class="d-flex align-items-center flex-column gap-2" >
                <img class="w-100" :src="campaignImage" alt="image"/>
                <i style="cursor:pointer;" class="uil uil-trash-alt text-danger font-size-18" @click="removeImage"></i>
              </div>
              <vue-dropzone
                  v-else
                  id="dropzone_primary"
                  ref="myVueDropzone_primary"
                  :use-custom-slot="true"
                  :options="dropzoneOptions"
                  @vdropzone-files-added="selectFile"
                  no-progress-bar
              >
                <div style="cursor: pointer" class="dropzone-custom-content">
                  <i class="display-4 text-muted text-center bx bxs-cloud-upload"></i>
                  <h4>Drop file here or click to upload.</h4>
                </div>
              </vue-dropzone>
            </b-form-group>


          </b-card-text>
        </div>
      </div>
    </form>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="submitForm" :disabled="tryingToSubmit || showLoader">
        <b-spinner v-show="tryingToSubmit" small></b-spinner>Submit
      </b-button>
    </template>
  </b-modal>
</template>
